export const CONDITIONAL_VISIBILITY_PERSISTENCE_FAILURE_BEHAVIORS = [
  {
    value: "show-content",
    label: "Show content",
    description: "Keep content available when per-user visibility state is unavailable.",
  },
  {
    value: "hide-content",
    label: "Hide content",
    description: "Block content until per-user visibility state can be loaded and saved.",
  },
] as const;

export type ConditionalVisibilityPersistenceFailureBehavior =
  typeof CONDITIONAL_VISIBILITY_PERSISTENCE_FAILURE_BEHAVIORS[number]["value"];

export function normalizeConditionalVisibilityPersistenceFailureBehavior(
  value: unknown,
): ConditionalVisibilityPersistenceFailureBehavior {
  return value === "hide-content" ? "hide-content" : "show-content";
}

export function shouldShowContentOnVisibilityPersistenceFailure(
  value: unknown,
): boolean {
  return normalizeConditionalVisibilityPersistenceFailureBehavior(value)
    === "show-content";
}
